exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".newsletter .panel {\n  padding: 2rem 1rem; }\n\n.newsletter .icon {\n  font-size: 350%;\n  color: #d1d6db;\n  text-align: center; }\n\n.newsletter .title {\n  font-weight: bold; }\n\n.newsletter .description {\n  color: #898a8e;\n  margin-bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/newsletter/show-newsletter/show-newsletter.component.scss
// module id = 408
// module chunks = 0